var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container p-30px border-grey02" },
    [
      _c("div", { staticClass: "flex justify-between items-center mb-30px" }, [
        _c("div", { staticClass: "w-fit" }, [
          _c("div", { staticClass: "flex items-center" }, [
            _c("img", {
              staticClass: "h-30px mr-10px",
              attrs: { src: "/images/svg/projects/icon-list.svg" },
            }),
            _vm._v(" "),
            _c("h1", { staticClass: "text-black01 font-medium" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", {}),
        _vm._v(" "),
        _c("div", {}, [
          _c(
            "div",
            {},
            [
              _vm.search
                ? [
                    _c("span", { staticClass: "search-result-count" }, [
                      _c(
                        "span",
                        { staticClass: "search-result-count-number" },
                        [_vm._v(_vm._s(_vm.project_archives.total))]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s("件見つかりました") +
                          "\n          "
                      ),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px",
                          on: { click: _vm.openSearchDialog },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s("完了検索") +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ],
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container__content" }, [
        _c("table", { staticClass: "project-table overflow-x-scroll" }, [
          _c("thead", [
            _c(
              "tr",
              [
                _vm._l(_vm.tableHeaders, function (header, index) {
                  return [
                    !(header.hide_for_affiliate == true && _vm.isUserAffiliate)
                      ? _c(
                          "th",
                          { key: index },
                          [
                            !header.sortable
                              ? [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(header.name) +
                                      "\n              "
                                  ),
                                ]
                              : [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(header.key)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(header.name) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa",
                                    class: {
                                      "fa-sort":
                                        _vm.sortProperty != header.key ||
                                        (_vm.sortDirection != "asc" &&
                                          _vm.sortDirection != "desc"),
                                      "fa-sort-up":
                                        _vm.sortProperty == header.key &&
                                        _vm.sortDirection == "asc",
                                      "fa-sort-down":
                                        _vm.sortProperty == header.key &&
                                        _vm.sortDirection == "desc",
                                    },
                                  }),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.project_archives.data, function (archive) {
              return _c("tr", { key: archive.id }, [
                _c("td", { staticClass: "w-3/10 min-w-100px" }, [
                  _c(
                    "a",
                    {
                      staticClass: "opacity decoration",
                      attrs: {
                        href: _vm.buildProjectArchiveShowUrl(archive.id),
                      },
                    },
                    [_vm._v(_vm._s(archive.friendly_id))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "w-3/10 min-w-100px" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formatISODate(archive.date, "yyyy/MM")) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                !_vm.isUserAffiliate
                  ? _c("td", { staticClass: "w-3/10 min-w-100px" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(archive.project_count) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container__footer" }, [
        _c("div", { staticClass: "container__footer__block" }, [
          _c("div", [
            _c(
              "div",
              [
                _c("pagination", {
                  attrs: {
                    links: _vm.project_archives.links,
                    totalPages: _vm.project_archives.last_page,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.search
              ? _c("div", { staticClass: "footer-buttons" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px lg:mr-10px lg:mb-0 mb-10px",
                      attrs: { href: _vm.urls.projects.archive },
                    },
                    [_vm._v(_vm._s("一覧へ戻る"))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "block text-white00 text-xs px-20px leading-loose bg-grey04 rounded-20px",
                      on: { click: _vm.openSearchDialog },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s("検索条件変更") +
                          "\n          "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("search-dialog", {
        attrs: { "dialog-data": _vm.searchDialog },
        on: {
          "close-dialog": _vm.closeSearchDialog,
          "submit-search": _vm.submitSearch,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }